// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionNavigation_container__DoYMU","runAnimation":"SectionNavigation_runAnimation__XIiSV","FadeFromBottomWithDelay":"SectionNavigation_FadeFromBottomWithDelay__yN_vF"};